module.exports = __webpack_public_path__ + "static/line1_5-90a6caa93c1263709443cc4446257c41.jpg";